(ns measure.shared-report-download-page.view
  (:require ["@mui/material/CircularProgress$default" :as CircularProgress]
            ["@mui/material/Stack$default" :as Stack]
            ["@mui/material/Typography$default" :as Typography]
            ["src/svg/artwork/broken-link.svg$default" :as BrokenLink]
            ["src/svg/artwork/cloud-with-files.svg$default" :as CloudWithFiles]
            ["src/svg/artwork/hourglass.svg$default" :as Hourglass]
            [common.db.effects.binary :as binary]
            [common.queries :refer [use-query]]
            [measure.shared-report-download-page.queries :as q]
            [uix.core :as uix :refer [$ defui]]
            [uix.re-frame :refer [use-subscribe]]))

(defui artwork-and-message [{:keys [artwork title description]}]
  ($ Stack
     {:direction "column"
      :alignItems "center"
      :spacing 2}
     artwork
     ($ Typography
        {:variant "h2"}
        title)
     ($ Typography
        {:maxWidth "480px"
         :align "center"}
        description)))

(defui error-view [{:keys [error-code]}]
  (let [props (case error-code
                ("link-expired" "download-expired") {:artwork ($ Hourglass {:width 240 :height 240})
                                                     :title "Link has expired."
                                                     :description ($ Typography "Sorry, your report link has expired. Remember, our links are valid
                                                                                 for one week only. Please ask the creater to generate a new report.")}
                "invalid-link" {:artwork ($ BrokenLink {:width 240 :height 240})
                                :title "Link is invalid"
                                :description ($ Typography "This download link is invalid.")}
                {:artwork ($ BrokenLink {:width 240 :height 240})
                 :title "Error"
                 :description ($ Typography "We've encountered an error, please try again later.")})]
    ($ artwork-and-message props)))

(defui download-report-view
  [{:keys [share-token]}]
  (let [[state set-state] (uix/use-state {:status :pending
                                          :error-code nil})]
    (uix/use-effect (fn []
                      (-> (q/get-shared-report {:share-token share-token})
                          (.then (fn [{:keys [blob filename]}]
                                   (set-state {:status :success})
                                   (binary/download blob filename)))
                          (.catch (fn [resp]
                                    (set-state {:status :failure
                                                :error-code (when (= 410 (.-status resp))
                                                              "download-expired")})))))
                    [share-token])
    (case (:status state)
      :pending ($ CircularProgress)
      :failure ($ error-view {:error-code (:error-code state)})
      :success ($ artwork-and-message {:artwork ($ CloudWithFiles {:width 240 :height 240})
                                       :title "Report downloaded"
                                       :description "Your report was successfully downloaded. You can safely close this tab."}))))

(defui shared-report-download-page []
  (let [{:keys [share-link-id]} (use-subscribe [:url-context])

        {token-error :isError
         {:keys [share-token]} :data
         {error-data :data} :error} (use-query (q/share-token-query {:share-link-id share-link-id}))]
    ($ Stack
       {:direction "column"
        :alignItems "center"
        :justifyContent "center"
        :sx #js {:py 2
                 :width "100%"
                 :height "100%"}}
       (cond
         (some? share-token) ($ download-report-view {:share-token share-token})
         token-error ($ error-view {:error-code (-> error-data
                                                    (js->clj :keywordize-keys true)
                                                    :error-code)})
         :else ($ CircularProgress)))))
